import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExamsService } from "../../exams.service";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { AutotextService } from "../../autotext.service";
import { LoginService } from "../../login.service";
import { PatientsService } from "../../patients.service";
import { Subscription, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CardioService } from "../cardio.service";
import { SignatureService } from "src/app/signature.service";
import { HttpClient } from "@angular/common/http";
import { PdfprintService } from "src/app/pdfprint.service";
import { Exam } from "../../interfaces/exams.service/types";

@Component({
    selector: "app-cardio-summary",
    templateUrl: "./cardio-summary.component.html",
    styleUrls: ["./cardio-summary.component.scss"],
    standalone: false
})
export class CardioSummaryComponent implements OnInit, OnDestroy {
  summaryForm: UntypedFormGroup;
  lastDiagnosis: string;
  lastRecommendations: string;
  lastFindings: string;
  prnerr: string;
  trerr;
  subscritpion: Subscription;
  checkleumit: boolean;
  isFetalEcho: boolean = false;
  signed: Date;
  signer: String;
  HMO: string;
  PRN: string;
  showPrintOpts: boolean = false;
  oldSignature: string | null = null;

  constructor(
    public es: ExamsService,
    private fb: UntypedFormBuilder,
    public atS: AutotextService,
    public ls: LoginService,
    private ps: PatientsService,
    private cs: CardioService,
    public signatureService: SignatureService,
    private http: HttpClient,
    public pdfService: PdfprintService
  ) {
    this.summaryForm = this.fb.group({
      Repeat1: [""],
      Repeat2: [""],
      Diagnosis: [""],
      Recomm: [""],
      ReferingDoc: [""],
      ExamMethod: [""],
      DiagnosisCodes: [""],
      Anomalies: [""],
      Abdominal: [""],
      Vaginal: [""],
      Transperineal: [""],
      Rectal: [""],
      DiagnosisCopy: [""],
      HMO: [""],
      PRN: [""],
      TreatmentCode: [""],
      FollowUpExam: [""],
      Quality: [""],
      IndicationCodes: [""],
      AnomaliesIndication: [""],
      ImagingQuality: [""],
      LVEF: [""],
      Conclusions: [""],
      Assessments: [""],
      Summary: [""],
      OtherStaff: [""],
      Findings: [""],
      AnomaliesStress: [""],
      LVEFmeas: [],
    });
    if (!this.es.isClosed) {
      this.es.getLastSummary().subscribe(
        (data) => {
          this.lastDiagnosis = data["diagnosis"];
          this.lastRecommendations = data["recommendations"];
          if (data["summary"]) this.lastFindings = data["summary"]["Anomalies"];
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  addLastDiagnosis() {
    if (this.summaryForm.get("Diagnosis").value)
      this.summaryForm
        .get("Diagnosis")
        .setValue(this.summaryForm.get("Diagnosis").value + this.lastDiagnosis);
    else this.summaryForm.get("Diagnosis").setValue(this.lastDiagnosis);
    this.summaryForm.get("DiagnosisCopy").setValue(1);
  }

  addLastRecomm() {
    if (this.summaryForm.get("Recomm").value)
      this.summaryForm
        .get("Recomm")
        .setValue(this.summaryForm.get("Recomm").value + this.lastRecommendations);
    else this.summaryForm.get("Recomm").setValue(this.lastRecommendations);
  }

  addLastFindings() {
    if (this.summaryForm.get("Anomalies").value)
      this.summaryForm
        .get("Anomalies")
        .setValue(this.summaryForm.get("Anomalies").value + this.lastFindings);
    else this.summaryForm.get("Anomalies").setValue(this.lastFindings);
  }

  ngOnInit() {
    this.subscritpion = this.es.formLoaded$.subscribe(() => {
      //prn and hmo moved to cardio general
      this.cs.getHMOinfo(this.es.examID).subscribe(
        (data) => {
          if (data["HMO"]) this.HMO = data["HMO"];
          if (data["ReferralNum"] && data["ReferralNum"] != "") this.PRN = data["ReferralNum"];
        },
        (error) => {
          console.log(error);
        }
      );
    });
    if (this.ls.PRNcheck)
      this.es.fillForm(this.summaryForm, "summary", false, true, ["PRN", "TreatmentCode"]);
    else this.es.fillForm(this.summaryForm, "summary", false, true);
    this.es.getClosing().subscribe(
      (data) => {
        if (data["ClosedDate"]) {
          this.signed = new Date(data["ClosedDate"]);
        }
        if (data["Signer"]) this.signer = data["Signer"];
      },
      (error) => {
        console.log(error);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscritpion) {
      this.subscritpion.unsubscribe();
    }
  }

  checkPRN() {
    let prn = this.summaryForm.get("PRN").value;
    let tcode = this.summaryForm.get("TreatmentCode").value;
    this.ps.checkPRN(this.ps.currentPatient.ID, prn, tcode).subscribe(
      (data) => {
        if (data["response"] == "") {
          //verified
          this.prnerr = null;
          this.summaryForm.get("PRN").disable({ emitEvent: false });
          this.summaryForm.get("TreatmentCode").disable({ emitEvent: false });
          this.es.saveVals("PRN", prn, false);
          this.es.saveVals("TreatmentCode", tcode, false);
          if (this.es.isClosed) this.es.saveVals("HMO", "Leumit", false);
          this.summaryForm.get("HMO").disable({ emitEvent: false });
          this.checkleumit = false;
        } else {
          this.prnerr = data["response"];
        }
      },
      (err) => {
        this.prnerr = err["error"];
      }
    );
  }
  resetGrp(item: string) {
    if (!this.es.isClosed) this.summaryForm.get(item).setValue(null);
  }

  checklength() {
    if (!this.ls.PRNcheck) return;
    if ((this.summaryForm.get("PRN").value + "").length < 9) {
      if (this.summaryForm.get("PRN").value) this.prnerr = "PRN invalid";
    } else {
      this.prnerr = null;
      this.checkleumit = true;
    }
    this.trerr =
      this.summaryForm.get("TreatmentCode").value &&
      (this.summaryForm.get("TreatmentCode").value + "").length < 5;
  }
  //original show sign
  // showSign() {
  //   if (
  //     this.es.ExamType == "Stress" ||
  //     this.es.ExamType === "Holter ECG" ||
  //     this.es.ExamType == "Duplex Carotid"
  //   )
  //     return (
  //       this.ls.userType == "doctor" &&
  //       !this.es.isClosed &&
  //       !this.signed &&
  //       !this.showPrintOpts &&
  //       !this.signatureService.isExamSigned(this.es.examObject) &&
  //       (this.HMO != "Macabi" || this.PRN)
  //     );
  //   if (
  //     this.es.ExamType == "Consultation Letter" ||
  //     this.es.ExamType == "Pulmonary functional assessment"
  //   ) {
  //     return (
  //       this.ls.userType == "doctor" &&
  //       !this.showPrintOpts &&
  //       !this.signatureService.isExamSigned(this.es.examObject) &&
  //       !this.es.isClosed &&
  //       !this.signed
  //     );
  //   } else
  //     return (
  //       this.ls.userType == "doctor" &&
  //       !this.es.isClosed &&
  //       !this.signed &&
  //       !this.showPrintOpts &&
  //       !this.signatureService.isExamSigned(this.es.examObject) &&
  //       (this.summaryForm.get("LVEFmeas").value || this.summaryForm.get("LVEF").value) &&
  //       (this.HMO != "Macabi" || this.PRN)
  //     );
  // }

  showSign(): boolean {
    const exam = this.es.examObject;
    const type = this.es.ExamType;

    const isDoctor = this.ls.userType === "doctor";
    const notClosed = !this.es.isClosed;
    const notSigned = !this.signed;
    const noPrintOpts = !this.showPrintOpts;
    const examNotSigned = !this.signatureService.isExamSigned(exam);

    if (!(isDoctor && notClosed && notSigned && noPrintOpts && examNotSigned)) {
      return false;
    }
    if (this.es.patServ.getPat()?.ID === 'default') {
      return false;
    }

    switch (type) {
      case "Consultation Letter":
      case "Pulmonary functional assessment":
      case "Methacholine test":
        return true;

      case "Stress":
      case "Holter ECG":
      case "Duplex Carotid":
        return this.HMO !== "Macabi" || !!this.PRN;

      default:
        const form = this.summaryForm;
        const hasLVEF = !!(form.get("LVEFmeas")?.value || form.get("LVEF")?.value);
        return hasLVEF && (this.HMO !== "Macabi" || !!this.PRN);
    }
  }

  addFindingsStressEcho() {
    this.cs.getFindings().subscribe(
      (result) => {
        let stressEcho = "";
        let currentAnomalies = this.summaryForm.get("Anomalies").value || "";

        // Function to append new findings if not already present
        const appendIfNew = (existing, addition) => {
          let additions = addition.trim().split("\n");
          let existingLines = new Set(existing.trim().split("\n"));
          let newAdditions = additions.filter((line) => !existingLines.has(line)).join("\n");
          return newAdditions ? (existing ? newAdditions + "\n" + existing : newAdditions) : existing;
        };

        // Stress Echo:
        for (let r in result["stressEcho"]) {
          if (result["stressEcho"][r] && !currentAnomalies.includes(result["stressEcho"][r]))
            stressEcho += result["stressEcho"][r] + "\n";
        }
        stressEcho = appendIfNew(currentAnomalies, stressEcho);

        if (stressEcho) {
          this.summaryForm.get("Anomalies").setValue(stressEcho);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  addFindingsStress() {
    this.cs.getFindings().subscribe(
      (result) => {
        let stress = "";
        let currentAnomaliesStress = this.summaryForm.get("AnomaliesStress").value || "";

        // Function to append new findings if not already present
        const appendIfNew = (existing, addition) => {
          let additions = addition.trim().split("\n");
          let existingLines = new Set(existing.trim().split("\n"));
          let newAdditions = additions.filter((line) => !existingLines.has(line)).join("\n");
          return newAdditions ? (existing ? newAdditions + "\n" + existing : newAdditions) : existing;
        };

        // Stress:
        for (let r in result["stress"]) {
          if (result["stress"][r] && !currentAnomaliesStress.includes(result["stress"][r]))
            stress += result["stress"][r] + "\n";
        }
        stress = appendIfNew(currentAnomaliesStress, stress);

        if (stress) {
          this.summaryForm.get("AnomaliesStress").setValue(stress);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  signClose() {
    this.es.signExam(this.ls.getUserName()).subscribe(
      (d) => {
        this.signer = this.ls.getUserName();
        this.signed = new Date();
        this.showPrintOpts = false;
        this.es.signed = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // old closePreview
  // closePreview(event$: string) {
  //   if (event$ == "sign") this.signClose();
  //   this.showPrintOpts = false;
  // }

  closePreview(event$: string) {
    if (event$ === "sign") {
      this.signExam(false);
    } else if (event$ === "signShowPrint") {
      this.signExam(true);
    }
    this.showPrintOpts = false;
  }

  async signExam(showPrint: boolean = false) {
    const examId = this.es.examID;
    const data = {
      signedBy: this.ls.getUserName(),
      signedDate: new Date(),
    };
    this.es.awaitPrintHistory = true;
    const skipPrint = true;
    try {
      this.http.post(`/api/newExams/signature/sign/${examId}`, data).subscribe((data: Exam) => {
        const printLanguage = "he-IL";
        if (showPrint) {
          this.es.exitExam(skipPrint);
          this.summaryForm.disable({ emitEvent: false });
          this.es.examSigned$.next(data);
          this.showPrintOpts = true;
        } else {
          this.es.exitExam(skipPrint);
          this.summaryForm.disable({ emitEvent: false });
          this.es.isClosed = true;
          this.showPrintOpts = false;
          this.es.examSigned$.next(data);
          this.http
            .get(
              `/api/printpdf/${this.es.examID}/${this.es.patServ.getPat().PID}/${printLanguage}/${
                this.pdfService.printCharts ? "y" : "n"
              }/${this.pdfService.printImages ? "y" : "n"}/${this.pdfService.Style}/${
                this.pdfService.perPage
              }/n`
            )
            .subscribe(
              () => {
                this.es.awaitPrintHistory = false;
              },
              (error) => {
                console.log(error);
                this.es.awaitPrintHistory = false;
              }
            );
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
